import { trackEvent } from '@/lib/analytics'

export type TalentPoolGtmProps = Record<string, string | number | boolean | null>

export const pushTalentPoolGtmEvent = (
  event: string,
  properties?: TalentPoolGtmProps,
) => {
  if (typeof window === 'undefined') return
  // trackEvent already publishes to Umami and pushes the GA4 event into
  // dataLayer (in production or with NEXT_PUBLIC_ANALYTICS_DEBUG). Delegating
  // keeps this consistent and avoids a double dataLayer push (GA4 over-count).
  trackEvent(event, properties)
}
